<template>
  <section style="width: 100%; z-index: 5">
    <div class="mb-0">
      <vue-content-loading :width="600" :height="45">
        <rect x="0" y="0" rx="5" ry="5" width="600" height="40" />
      </vue-content-loading>
    </div>
    <div class="mb-10">
      <vue-content-loading :width="600" :height="10">
        <rect x="0" y="0" rx="5" ry="5" width="320" height="10" />
      </vue-content-loading>
    </div>
    <div class="mb-25">
      <vue-content-loading :width="600" :height="360">
        <rect x="0" y="0" rx="5" ry="5" width="600" height="360" />
      </vue-content-loading>
    </div>
    <!-- <div class="mb-25">
      <vue-content-loading :width="600" :height="320">
        <rect x="0" y="0" rx="4" ry="4" width="590" height="10" />
        <rect x="0" y="15" rx="4" ry="4" width="480" height="10" />
        <rect x="0" y="30" rx="4" ry="4" width="600" height="10" />
        <rect x="0" y="45" rx="4" ry="4" width="260" height="10" />

        <rect x="0" y="70" rx="4" ry="4" width="560" height="10" />
        <rect x="0" y="85" rx="4" ry="4" width="320" height="10" />
        <rect x="0" y="100" rx="4" ry="4" width="450" height="10" />
        <rect x="0" y="115" rx="4" ry="4" width="200" height="10" />
        <rect x="0" y="130" rx="4" ry="4" width="590" height="10" />
        <rect x="0" y="130" rx="4" ry="4" width="590" height="10" />

        <rect x="60" y="160" rx="4" ry="4" width="480" height="10" />
        <rect x="140" y="175" rx="4" ry="4" width="320" height="10" />
        <rect x="75" y="195" rx="4" ry="4" width="450" height="10" />
        <rect x="200" y="210" rx="4" ry="4" width="200" height="10" />

        <rect x="0" y="230" rx="4" ry="4" width="560" height="10" />
        <rect x="0" y="245" rx="4" ry="4" width="320" height="10" />
        <rect x="0" y="260" rx="4" ry="4" width="450" height="10" />
        <rect x="0" y="275" rx="4" ry="4" width="200" height="10" />
        <rect x="0" y="290" rx="4" ry="4" width="590" height="10" />
        <rect x="0" y="305" rx="4" ry="4" width="590" height="10" />
      </vue-content-loading>
    </div>

    <div>
      <vue-content-loading :width="600" :height="60">
        <rect x="0" y="0" rx="4" ry="4" width="120" height="60" />

        <rect x="140" y="5" rx="4" ry="4" width="220" height="20" />
        <rect x="370" y="5" rx="4" ry="4" width="90" height="20" />
        <rect x="470" y="5" rx="4" ry="4" width="130" height="20" />

        <rect x="140" y="35" rx="4" ry="4" width="90" height="20" />
        <rect x="240" y="35" rx="4" ry="4" width="85" height="20" />
        <rect x="335" y="35" rx="4" ry="4" width="130" height="20" />
        <rect x="475" y="35" rx="4" ry="4" width="60" height="20" />
        <rect x="545" y="35" rx="4" ry="4" width="55" height="20" />
      </vue-content-loading>
    </div> -->
  </section>
</template>

<script>
import VueContentLoading from 'vue-content-loading';

export default {
  name: 'PostLoading',
  components: {
    VueContentLoading,
  },
};
</script>

<style lang="scss" scoped>
section {
  // background: #f7f6f8;

  & .mb-25 {
    margin-bottom: 25px !important;
  }
  & .mb-0 {
    margin-bottom: 0px !important;
  }
  & .mb-10 {
    margin-bottom: 10px !important;
  }
}
@media all and (min-width: 300px) and (max-width: 1000px) {
  section {
    max-height: 100vh;
    min-height: 100vh !important;
    opacity: 0;
    display: none;
  }
}
</style>
